import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-2xl w-full text-center"
      >
        <div className="relative mb-8">
          <div className="absolute inset-0 bg-gradient-to-r from-[#15803d] to-[#0c5527] blur-3xl opacity-30 rounded-full" />
          <motion.div 
            animate={{ y: [-10, 10, -10] }}
            transition={{ duration: 4, repeat: Infinity }}
            className="relative mx-auto w-64 h-64"
          >
            <svg viewBox="0 0 200 200"  className="w-full h-full">
              <path
                fill="#15803d"
                d="M42.7,-59.1C54.8,-52.7,63.7,-40.1,68.4,-26.1C73.1,-12.1,73.7,3.3,69.3,16.3C64.9,29.3,55.5,40,44.4,50.1C33.3,60.2,20.5,69.8,4.2,73.3C-12.1,76.8,-25.9,74.1,-38.1,66.7C-50.3,59.3,-60.8,47.2,-66.1,33.3C-71.3,19.4,-71.2,3.7,-66.6,-9.3C-62,-22.3,-52.9,-32.6,-42.8,-39.5C-32.6,-46.4,-21.5,-49.9,-8.7,-56.7C4.1,-63.5,18.6,-73.6,32.1,-71.8C45.6,-70,58.1,-56.3,61.7,-41.1C65.3,-25.8,60.1,-9,59.4,8.4C58.7,25.8,62.5,51.5,55.7,62.7C48.9,73.9,31.4,70.6,16.7,67.4C2,64.2,-10,61.1,-21.1,57.2C-32.3,53.3,-42.6,48.6,-52.9,41.2C-63.1,33.8,-73.3,23.7,-77.7,11.4C-82.1,-0.9,-80.8,-15.4,-74.6,-27.1C-68.3,-38.7,-57.2,-47.5,-44.6,-53.7C-32,-59.9,-17.9,-63.6,-2.4,-67.3C13.1,-71,26.2,-74.7,42.7,-59.1Z"
                transform="translate(100 100)"
              />
            </svg>
          </motion.div>
        </div>

        <h1 className="text-9xl font-bold text-gray-800 dark:text-white mb-4">
          404
        </h1>
        
        <motion.h2
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-3xl font-semibold text-gray-700 dark:text-gray-300 mb-6"
        >
          Oops! Page Not Found
        </motion.h2>
        
        <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
          The page you're looking for might have been moved, deleted, or never existed.
        </p>

        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Link
            to="/"
            // from-[#15803d] to-[#0c5527]
            className="inline-block bg-[#15803d] hover:bg-[#15803d]/80 text-white px-8 py-3 rounded-lg 
                     transition-colors duration-300 text-lg font-medium shadow-lg"
          >
            Return Home
          </Link>
        </motion.div>

        <div className="mt-8 flex justify-center space-x-6">
          {[...Array(3)].map((_, i) => (
            <motion.div
              key={i}
              animate={{ y: [0, -20, 0] }}
              transition={{ duration: 2 + i, repeat: Infinity }}
              className="w-3 h-3 bg-[#15803d] rounded-full"
            />
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;